import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import $ from 'jquery';
import swal from "sweetalert2";
import axios from 'axios';
import { toast } from 'react-toastify'; 


const CustomMultiValueLabel = (props) => {
    return (
        <components.MultiValueLabel {...props}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{props.data.label}</span> {/* item name */}
                <small style={{ color: "var(--bs-primary)", fontWeight: 600 }}>
                    {props.data.schedule} {/* schedule name */}
                </small>
            </div>
        </components.MultiValueLabel> 
    );
};

const baseURL = process.env.REACT_APP_API_BASE_URL;
const Assign_Work = ({ show, onClose, slectedDate }) => {

    const baseURL1 = "http://192.168.3.110:1711/api";
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [staffAssignments, setStaffAssignments] = useState({}); 
    const [staffList, setStaffList] = useState([]);
    const [staff_count, setstaff_count] = useState(0);

    useEffect(() => {
        axios.get(`${baseURL}/dropdown/getstaff_by_role/5?branch_id=${branch_id}`)
            .then(response => {
                const items = Array.isArray(response.data?.data) ? response.data.data : [];
                setStaffList(items);
                setstaff_count(items.length);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }, []);

    const [hasFetched, setHasFetched] = useState(false);
    const [schedules, setSchedules] = useState([]);
    const [selectedSchedule, setSelectedSchedule] = useState(null);
 
    const fetchSchedules = async () => {
        try {
            const res = await axios.get(`${baseURL}/item-schedule/items/active`);
            const list = res.data?.data || [];

            setSchedules(list); 
            setSelectedSchedule("");

        } catch (err) {
            console.error("Failed to fetch schedules:", err);
        }
    };

    useEffect(() => {
        fetchSchedules();
    }, []);


    const scheduleOptions = schedules.map(schedule => ({
        value: schedule.sno,
        label: schedule.itemschedule_name || `tab-${schedule.sno}`,
    }));

    // const fetchAssignedWork = async (scheduleId) => {
    //     try {
    //         const response = await axios.get(`${baseURL}/assigned-staff-list?assignment_date=${formatDate(slectedDate)}&schedule_id=${scheduleId}`);
    //         const result = response.data;

    //         if (result.status_code === 200 && Array.isArray(result.data)) {
    //             const newAssignments = {};

    //             result.data.forEach(schedule => {
    //                 schedule.staff.forEach(staff => {
    //                 const staffId = parseInt(staff.staff_id);
    //                 if (!isNaN(staffId)) {
    //                     const itemIds = staff.items.map(item => parseInt(item.item_id));
    //                     newAssignments[staffId] = itemIds;
    //                 }
    //                 });
    //             });

    //             setStaffAssignments(newAssignments);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching assignments:", error);
    //     }
    // };


    const fetchAssignedWork = async (scheduleId) => {
        try {
            const response = await axios.get(
                `${baseURL}/assigned-staff-list?assignment_date=${formatDate(slectedDate)}&schedule_id=${scheduleId}`
            );

            const result = response.data;

            if (result.status_code === 200 && Array.isArray(result.data) && result.data.length > 0) {
                const newAssignments = {};

                result.data.forEach(schedule => {
                    schedule.staff.forEach(staff => {
                        const staffId = parseInt(staff.staff_id);

                        const itemIds = staff.items.map(item => parseInt(item.item_id));

                        // 🟩 MERGE with old assignments instead of replacing
                        newAssignments[staffId] = [
                            ...(staffAssignments[staffId] || []),
                            ...itemIds
                        ].filter((v, i, arr) => arr.indexOf(v) === i);
                    });
                });

                setStaffAssignments(prev => ({ ...prev, ...newAssignments }));
            }

        } catch (error) {
            console.error("Error fetching assignments:", error);
        }
    };

    const formatDate = (date) => {
        const d = new Date(date); // ensures it's a Date object
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [itemlist, setitem] = useState([]);
    const [item_count, setitemcount] = useState(0);

    const fetchItem = async () => {
        const params = {
            date: formatDate(slectedDate),
            schedule_id: selectedSchedule,
            branch_id: branch_id,
        };

        try {
            const response = await axios.get(`${baseURL}/schedule-with-fooditems-list`, { params });
            const items = Array.isArray(response.data?.data) ? response.data.data : [];
            // const formatted = items.map(item => ({
            //     value: item.item_id,
            //     label: item.item_name,
            // }));
            const formatted = items.map(item => ({
                value: item.item_id,
                label: item.item_name, // dropdown shows only item name
                schedule: item.schedule_name, // keep schedule for later
            }));




            setitemcount(items.length);

            // Collect ALL selected item IDs from all staff
            const selectedItemIds = Object.values(staffAssignments).flat();

            // Keep old selected items
            const oldSelected = itemlist.filter(i => selectedItemIds.includes(i.value));

            // Merge and remove duplicates
            const merged = [...formatted];

            oldSelected.forEach(opt => {
                if (!merged.find(i => i.value === opt.value)) {
                    merged.push(opt);
                }
            });

            setitem(merged);

        } catch (err) {
            console.error("Error fetching items:", err);
        }
    };

    useEffect(() => {
        fetchItem();
        fetchAssignedWork(selectedSchedule);
    }, [selectedSchedule]);

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
              height: 60,
        }),
    };

    const tableRef = useRef(null);

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const DisplayformatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {}; 
        if (Object.keys(staffAssignments).length === 0) {
            newErrors.type = "At least one staff must be assigned an item.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {

        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = Object.entries(staffAssignments).map(([staff_id, item_ids]) => ({
            staff_id: parseInt(staff_id),
            assignment_date: formatDate(slectedDate), // assume selectedDate is in state
            item_id: item_ids,
        }));

        console.log('Payload:', payload);

        axios.post(`${baseURL}/assign-staff`, payload)
            .then(response => {
                // handle success
                console.log('Assigned successfully:', response.data);
                toast.success("Staff Assigned Successfully!");
                onClose();
            })
            .catch(error => {
                console.error('Error assigning work:', error);
                toast.error("Staff Assign Failed");
                onClose();
            });
    };

 
    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Work Assign</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-3 mb-3">
                            <div className='row mb-2'>
                                <div className="mb-2">
                                    <label class="col-12 text-black font-w500 fs-7">Preparation Date</label>
                                    <label class="col-12 text-primary font-w500 fs-6">{DisplayformatDate(slectedDate)}</label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-lg-3 mb-3">
                            <div className='row mb-2'>
                                <div className="mb-2">
                                    <label class="col-12 text-black font-w500 fs-7">Total Staff</label>
                                    <Badge bg="primary" className='font-w500 fs-6 text-white'>{staff_count}</Badge>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="col-12 text-black font-w500 fs-7">Select Schedule</label>

                            <Select
                                placeholder="Select Schedule"
                                options={[
                                    { value: "", label: "All Schedules" },
                                    ...scheduleOptions
                                ]}
                                value={[
                                    { value: "", label: "All Schedules" },
                                    ...scheduleOptions
                                ].find(opt => opt.value === selectedSchedule) || null}
                                onChange={(option) => setSelectedSchedule(option.value)}
                                components={{ Group }}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-lg-12 mb-2'>
                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll', maxHeight: '500px', overflowY: 'scroll' }}>
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-100px'>Master</th>
                                        <th className='min-w-100px'>Item</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                   
                                         {staffList.map((data) => {
                                        const selectedByOthers = Object.entries(staffAssignments)
                                            .filter(([id]) => parseInt(id) !== data.sno)
                                            .flatMap(([, items]) => items); 

                                        const filteredItemList = itemlist.filter(
                                            (item) => !selectedByOthers.includes(item.value)
                                        );
                                        return (
                                            <tr key={data.sno}>
                                                <td>
                                                    <label className='font-w500 text-black fs-6'>{data.name}</label>
                                                </td>
                                               {/* <Select
                                                        placeholder="Select Item"
                                                        options={filteredItemList}
                                                        isMulti
                                                        // components={{ Group }}
                                                        components={{ Group, Option: CustomOption }}
                                                        styles={customStyles}
                                                        value={itemlist.filter(opt => staffAssignments[data.sno]?.includes(opt.value))}
                                                        onChange={(selectedOptions) => {
                                                            const selectedIds = selectedOptions.map(opt => opt.value);

                                                            setStaffAssignments(prev => {
                                                                const updated = {};

                                                                for (const [staffId, items] of Object.entries(prev)) {
                                                                    if (parseInt(staffId) === data.sno) {
                                                                        updated[staffId] = selectedIds;
                                                                    } else {
                                                                        updated[staffId] = items.filter(id => !selectedIds.includes(id));
                                                                    }
                                                                }

                                                                return { ...updated, [data.sno]: selectedIds };
                                                            });
                                                        }}
                                                    /> */}
                                                  <td>
                                                    
                                                    <Select
                                                        placeholder="Select Item"
                                                        options={filteredItemList} // your formatted items
                                                        isMulti
                                                        components={{ Group, MultiValueLabel: CustomMultiValueLabel }}
                                                        styles={customStyles}
                                                        value={itemlist.filter(opt => staffAssignments[data.sno]?.includes(opt.value))}
                                                        onChange={(selectedOptions) => {
                                                            const selectedIds = selectedOptions.map(opt => opt.value);

                                                            setStaffAssignments(prev => {
                                                                const updated = {};
                                                                for (const [staffId, items] of Object.entries(prev)) {
                                                                    if (parseInt(staffId) === data.sno) {
                                                                        updated[staffId] = selectedIds;
                                                                    } else {
                                                                        updated[staffId] = items.filter(id => !selectedIds.includes(id));
                                                                    }
                                                                }
                                                                return { ...updated, [data.sno]: selectedIds };
                                                            });
                                                        }}
                                                    />

                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {errors.type && <div className="text-danger fs-8 mt-1">{errors.type}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Assign Work
                            <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Assign_Work;
